import { FaExclamationTriangle, FaBan } from 'react-icons/fa';
import { formatTimestamp } from '../../services/jobService';

const EarlierJobsModal = ({
  jobDate,
  earlierIncompleteJobs,
  cancellingEarlierJobs,
  onCancel,
  onDismiss,
  onCancelJobs,
  isHardBlock = false,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg">
        <h4 className={`text-lg font-semibold mb-4 flex items-center ${isHardBlock ? 'text-red-700' : 'text-gray-800'}`}>
          {isHardBlock
            ? <FaBan className="text-red-600 mr-2" />
            : <FaExclamationTriangle className="text-amber-500 mr-2" />
          }
          {isHardBlock
            ? 'Cannot Complete — Earlier Approved Jobs Exist'
            : 'Earlier Scheduled Jobs Found'
          }
        </h4>
        <div className="mb-4">
          {isHardBlock ? (
            <p className="text-gray-700 mb-3">
              You cannot complete a job scheduled for <strong>{formatTimestamp(jobDate)}</strong> while there{' '}
              {earlierIncompleteJobs.length === 1 ? 'is' : 'are'}{' '}
              <strong>{earlierIncompleteJobs.length}</strong> earlier <strong>approved</strong> job(s) for the same client and service.
              Jobs must be completed or cancelled in order.
            </p>
          ) : (
            <p className="text-gray-700 mb-3">
              You are completing a job scheduled for <strong>{formatTimestamp(jobDate)}</strong>, but there are{' '}
              <strong>{earlierIncompleteJobs.length}</strong> earlier job(s) for the same client and service that were not completed:
            </p>
          )}
          <div className="max-h-48 overflow-y-auto border rounded-md">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {earlierIncompleteJobs.map((earlierJob) => (
                  <tr key={earlierJob.id}>
                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      {formatTimestamp(earlierJob.jobDate)}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        earlierJob.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
                      }`}>
                        {earlierJob.status === 'approved' ? 'Approved' : 'Service Delayed'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {isHardBlock ? (
            <p className="mt-3 text-red-700 font-medium">
              Please complete or cancel these earlier jobs first, or remove them from your schedule below.
            </p>
          ) : (
            <>
              <p className="mt-3 text-gray-700">
                Would you like to remove these earlier jobs from your schedule?
              </p>
              <p className="mt-1 text-sm text-gray-500">
                Cancelled jobs can still be viewed in your job history.
              </p>
            </>
          )}
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-full shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            disabled={cancellingEarlierJobs}
          >
            {isHardBlock ? 'Go Back' : 'Cancel'}
          </button>
          {!isHardBlock && (
            <button
              onClick={onDismiss}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={cancellingEarlierJobs}
            >
              Keep Jobs &amp; Complete
            </button>
          )}
          <button
            onClick={onCancelJobs}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-500 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            disabled={cancellingEarlierJobs}
          >
            {cancellingEarlierJobs ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Cancelling...
              </>
            ) : (
              `Remove ${earlierIncompleteJobs.length} Job(s) & Complete`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EarlierJobsModal;

